import { StationSource } from './station-source';
import { Observable } from 'rxjs';

export class Station {
    enterpriseStationId: number;
    id: string;
    name: string;
    market: string;
    frequency: string;
    timeZone: string;
    format: string;
    stationLogoUrl: string;
    callLetters: string;
    band: string;
    favorite: boolean;
    detailsObserver?: Observable<Station>;
    stationSource?: StationSource;
}
